<template>
  <main id="main">
    <!-- Increased bottom padding (pb-8) to ensure scrolling reveals all content -->
    <div class="p-3 d-flex flex-column row-gap-4 pb-8">
        <header class="bg_white rounded-pill p-4 d-flex align-items-center shadow position-sticky top-0 slideInDown" style="z-index: 900;" @click="$router.push({ name: 'TeacherUserArea' })">
            <img style="width: 5.5rem; height: 5.5rem; object-fit: cover;" :src="userInfo.pic || require('@/assets/imgs/NoPath.svg')" class="rounded-pill border_theme ms-3" alt="" @error="$event.target.src = require('@/assets/imgs/NoPath.svg')">
            <div>
              <p class="text_color_theme ms-2 bold fadeIn font_large">{{ userInfo.name }}</p>
              <p class="bold font_medium ms-2 text_color_gray">{{ t('hello_dear') }}</p>
            </div>
        </header>

        <div v-if="slider.length > 0" class="slider-container mt-2 shadow_box bg_white rounded-4">
            <swiper
              :effect="'cube'"
              :grabCursor="true"
              :cubeEffect="{
                shadow: true,
                slideShadows: true,
                shadowOffset: 20,
                shadowScale: 0.94,
              }"
              :pagination="{ clickable: true }"
              :autoplay="{
                delay: 4000,
                disableOnInteraction: false,
              }"
              :loop="true"
              :modules="modules"
              class="mySwiper rounded-4"
            >
              <swiper-slide v-for="(slide, index) in slider" :key="index">
                <img :src="slide.pic" class="slider-image rounded-4" alt="Slider Image"/>
              </swiper-slide>
            </swiper>
        </div>
        <div v-else class="slider-container mt-2 bg_white rounded-4 d-flex justify-content-center align-items-center shadow_box">
             <p v-if="loading" class="text_color_gray">{{ t('loading') }}</p>
             <p v-else class="text_color_gray">{{ t('empty_list') }}</p>
        </div>

        <div class="d-flex flex-wrap justify-content-between align-items-stretch gap-3 mt-2">

            <section @click="$router.push({ name: 'TeacherUserArea' })"
                class="w-48 bg-white d-flex gap-2 flex-column justify-content-center align-items-center shadow_box rounded-4 p-4 cursor-pointer item_hover">
                <img src="@/assets/imgs/undraw_post-online_cjn9.svg" alt="تنظیمات پروفایل من" class="menu-icon">
                <h3 class="font_normal bold text-center mt-2">{{ t('profile_settings') }}</h3>
            </section>
            
            <section v-if="isTeacher" @click="$router.push({ name: 'TeacherCourseQA' })"
                class="w-48 bg-white d-flex gap-2 flex-column justify-content-center align-items-center shadow_box rounded-4 p-4 cursor-pointer position-relative item_hover">
                <div v-if="alarms.new_question > 0" class="notification-badge">{{ alarms.new_question }}</div>
                <img src="@/assets/imgs/undraw_questions_re_1fy7.svg" alt="پرسش و پاسخ دوره ها" class="menu-icon">
                <h3 class="font_normal bold text-center mt-2">{{ t('course_qa_btn') }}</h3>
            </section>
            
            <section v-if="isTeacher" @click="$router.push({ name: 'TeacherExamList' })"
                class="w-48 bg-white d-flex gap-2 flex-column justify-content-center align-items-center shadow_box rounded-4 p-4 cursor-pointer item_hover">
                <img src="@/assets/imgs/undraw_choose_5kz4.svg" alt="امتحانات" class="menu-icon">
                <h3 class="font_normal bold text-center mt-2">{{ t('exams_btn') }}</h3>
            </section>

        </div>
    </div>
    <TeacherBottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import TeacherBottomNav from '@/components/TeacherBottomNav.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/effect-cube'
import 'swiper/css/pagination'
import { EffectCube, Pagination, Autoplay } from 'swiper/modules'

export default {
  name: 'TeacherHomePage',
  components: {
    TeacherBottomNav,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      userInfo: {
        name: '',
        pic: ''
      },
      slider: [],
      isTeacher: false,
      alarms: {
        new_question: 0,
        new_chat: 0
      },
      loading: false
    }
  },
  setup() {
    return {
      modules: [EffectCube, Pagination, Autoplay],
    }
  },
  mounted() {
    this.fetchHomeData()
  },
  methods: {
    async fetchHomeData() {
      this.loading = true
      
      const userId = localStorage.getItem('user_id')
      
      try {
        const homeFormData = createFormData({
          teacher_id: userId,
          user_id: userId
        })
        const homeResponse = await apiClient.post('/teacher/home_page', homeFormData)
        
        if (homeResponse.data.status === 'ok' && homeResponse.data.data) {
          const data = homeResponse.data.data
          
          this.userInfo.name = data.user_info
          this.slider = data.slider || []
          this.isTeacher = data.lessons_teacher === 1
          this.alarms.new_question = data.alarm_new_question || 0
          this.alarms.new_chat = data.alarm_new_chat || 0

          if (this.alarms.new_chat > 0) {
              localStorage.setItem('teacher_has_unseen_chat', '1');
          } else {
              localStorage.setItem('teacher_has_unseen_chat', '0');
          }
        }

        const profileFormData = createFormData({
          action: 'teacher_info',
          user_id: userId
        });
        const profileResponse = await apiClient.post('/public_info', profileFormData);
        
        let serverPic = '';
        if (profileResponse.data) {
             serverPic = profileResponse.data.profile_pic || profileResponse.data.pic;
        }

        const localPic = localStorage.getItem('temp_profile_pic');
        const imageBaseUrl = 'https://back.ayendaman.org/storage/app/public/uploads/';

        if (localPic) {
           this.userInfo.pic = localPic;
        } else if (serverPic && serverPic !== 'nopic.png' && !serverPic.includes('nopic') && serverPic !== '') {
           
           if (serverPic.includes('uploads/') && serverPic.endsWith('/')) {
                this.userInfo.pic = ''; 
           } 
           else if (serverPic.startsWith('http')) {
             this.userInfo.pic = serverPic;
           } else {
             this.userInfo.pic = imageBaseUrl + serverPic;
           }
        } else {
           this.userInfo.pic = ''; 
        }

      } catch (error) {
        console.error("Error fetching data:", error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.slider-container {
  width: 100%;
  height: 24rem; 
  border-radius: 1.5rem;
  overflow: hidden;
}

.mySwiper {
  width: 100%;
  height: 100%;
}

.slider-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.menu-icon {
    width: 12rem;
    height: 12rem;
    object-fit: contain;
}

.item_hover {
    transition: transform 0.2s;
}
.item_hover:active {
    transform: scale(0.96);
}

.notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #FF0000;
    color: white;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.9rem;
    font-weight: bold;
    border: 2px solid white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    z-index: 10;
}
.font_medium {
  font-size: 1.2rem;
}
.font_large {
  font-size: 1.5rem;
}
/* Ensure enough padding at bottom for scrolling */
.pb-8 {
    padding-bottom: 8rem !important;
}
</style>